import { useQuery } from '@apollo/client';
import { isNil, sortBy } from 'lodash';
import { useContext, useMemo } from 'react';
import { Queries } from '@shared/api';
import { CardChannelContext } from '@shared/components/blocks/contexts/channel';
import { API } from '@shared/types/api';

interface UseTagOptionsResponse {
  options: API.TagOptionFragment[];
  refetch(): void;
  loading: boolean;
}

export function useAllTagOptions(): UseTagOptionsResponse {
  const channel = useContext(CardChannelContext);
  const { data, loading, refetch } = useQuery<
    API.ListCardFieldStringTagsQuery,
    API.ListCardFieldStringTagsQueryVariables
  >(Queries.card.listCardFieldStringTags, {
    variables: {
      input: { channelId: channel?.id ?? -1 },
    },
    skip: isNil(channel?.id),
  });

  const options = useMemo(() => {
    const tags: API.TagOptionFragment[] = data?.tags ?? [];
    return sortBy(tags, 'sortKey');
  }, [data?.tags]);

  return { options, loading, refetch };
}

export function useTagOptions(fieldName: string): UseTagOptionsResponse {
  const { options: allOptions, loading, refetch } = useAllTagOptions();
  const options = useMemo(() => {
    const filtered = allOptions?.filter(tag => tag.fieldName === fieldName) ?? [];
    return sortBy(filtered, t => !!t.archivedAt);
  }, [allOptions, fieldName]);
  return { options, loading, refetch };
}
